import { ICommandBase } from "@Quest/cqrs";


export class DeletePnlCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.DeletePnlCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string; 
	

	constructor(workspaceId: number, strategyId: string, pnlId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = pnlId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Pnls.Commands.DeletePnlCommandV1, TCh.Domain.Quest';
	}
}

export class CreatePnlCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.CreatePnlCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string; 
	Name: string;
	StartYear: number;
	StartMonth: number;
	Columns: string;

	constructor(workspaceId: number, strategyId: string, pnlId: string, name: string, startYear: number, startMonth: number, columns: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = pnlId;
		this.Name = name;
		this.StartYear = startYear;
		this.StartMonth = startMonth;
		this.Columns = columns;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Pnls.Commands.CreatePnlCommandV1, TCh.Domain.Quest';
	}
}

export class UpdatePnlCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.UpdatePnlCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string; 
	Name: string;
	StartYear: number;
	StartMonth: number;
	Columns: string;

	constructor(workspaceId: number, strategyId: string, pnlId: string, name: string, startYear: number, startMonth: number, columns: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = pnlId;
		this.Name = name;
		this.StartYear = startYear;
		this.StartMonth = startMonth;
		this.Columns = columns;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Pnls.Commands.UpdatePnlCommandV1, TCh.Domain.Quest';
	}
}
